function WheelIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm7.736 8h-3.16A5.02 5.02 0 0012 5.424V2.263A8.016 8.016 0 0117.736 8zM10 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM8 2.263v3.161A5.02 5.02 0 005.424 8h-3.16A8.015 8.015 0 018 2.263zM2.264 12h3.16A5.02 5.02 0 008 14.576v3.161A8.015 8.015 0 012.264 12zM12 17.737v-3.161A5.02 5.02 0 0014.576 12h3.16A8.015 8.015 0 0112 17.737z"
      ></path>
    </svg>
  );
}

export default WheelIcon;
